<template>
	<el-container >
		<el-header class="title" >
			<el-row type="flex" align="middle">
				<el-col :span="22" >
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item >首页</el-breadcrumb-item>
						<el-breadcrumb-item >产品公告管理</el-breadcrumb-item>
					</el-breadcrumb>
				</el-col>
				<el-col :span="2">
					<el-button class="el-button--primary vam" size="small" @click="toAddProductNoticePanel()">
						<i class="el-icon-plus">添加</i>
					</el-button>
					<!--<el-button class="el-button&#45;&#45;primary vam" size="mini" @click="query(1,99)"><i class="el-icon-plus">刷新</i></el-button>-->
				</el-col>
			</el-row>
		</el-header>
		<el-main>
			<el-table size="medium" :data="tableData" header-cell-class-name="table_header" :stripe="true" :height="tableHeight">
				<el-table-column prop="title" label="公告标题" >
					<template slot-scope="scope">
						<el-button
							@click.native.prevent="toEditProductNotice(scope.row)"
							type="text"
							size="medium">{{scope.row.title}}
						</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="productname" label="产品名称">
				</el-table-column>
				<el-table-column prop="description" label="公告内容"  :formatter="descriptionFormatter">
				</el-table-column>
				<el-table-column prop="publishtime" label="发布时间" :formatter="dateFormatter" width="150px">
				</el-table-column>
				<el-table-column label="操作" width="150">
					<template slot-scope="scope">
						<el-tooltip placement="top" popper-class="my-tooltip" :enterable="false" content="编辑公告信息">
							<el-button
								size="mini"
								class="el-button--primary" icon="el-icon-edit" circle @click.native.prevent="toEditProductNotice(scope.row)"></el-button>
						</el-tooltip>
						<el-button
							size="mini"
							class="el-button--danger" icon="el-icon-delete" circle @click="deleteProductNotice(scope.row)"></el-button>
					</template>
				</el-table-column>
			</el-table>
			<!--<div style="text-align:right;line-height: 40px;padding-top: 5px;background:#fff;">-->
				<!--<el-pagination @current-change="currentPageChangeHandler" background layout="total,prev, pager, next" :total="total" :page-size="pageSize">-->
				<!--</el-pagination>-->
			<!--</div>-->
		</el-main>
		<!--<el-dialog title="添加产品公告" :visible.sync="showAddProductNoticePanel" :destroy-on-close="true">-->
			<!--<add-product-notice-panel @addsuccess="addProductNoticeSuccess">-->

			<!--</add-product-notice-panel>-->
		<!--</el-dialog>-->
		<!--<el-dialog title="修改产品公告" :visible.sync="showEditProductNoticePanel" @opened="editProductNoticeDialogOpened" :destroy-on-close="true">-->
			<!--<edit-product-notice-panel ref="editProductNoticePanel" @updatesuccess="editProductNoticeSuccess" :productNoticeId="editProductNoticeId" ></edit-product-notice-panel>-->
		<!--</el-dialog>-->
	</el-container>
</template>

<script>
	import config from "../../../config/global.js";
	import axios from "axios"

	var getProductNoticeListUrl = config.host+'/backend/productnotice/list.json';
	var deleteProductNoticeUrl = config.host + "/backend/productnotice/delete.json";
    export default {
        name: "product-notice-query",
			components:{},
			data:function () {
				return {
					tableData: [],
					total:0,
					pageSize:50,
					currentPageIndex:1,
					tableHeight:window.innerHeight-120+"px",
					showAddProductNoticePanel:false,
					showEditProductNoticePanel:false,
					editProductNoticeId:null,
					loading:false
				}
			},
			mounted:function () {
				this.queryProductNotice();
			},
			methods:{
				dateFormatter:function (row, column) {
					var timeStr = row.publishtime;
					if(timeStr == null || timeStr.length<10)
						return;
					return timeStr.substring(0,10);
				},
				descriptionFormatter:function (row) {
					var description = row.description;
					if(description.length>50){
						return description.substring(0,50)+"...";
					}else {
						return description;
					}
				},
				toAddProductNoticePanel:function () {
					// this.showAddProductNoticePanel = true;
					this.$router.push({name:"addproductnotice"});
				},
				toEditProductNotice:function (item) {
					// this.editProductNoticeId = item.id;
					// this.showEditProductNoticePanel = true;
					this.$router.push({name:"editproductnotice",params:{"productnoticeid":item.id}});
				},
				editProductNoticeDialogOpened:function () {
					this.$refs.editProductNoticePanel.getProductNoticeDetail();
				},
				deleteProductNotice:function (item) {
					this.$confirm('您确定要删除该公告吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
					}).then(()=>{
						axios({
							method: 'post',
							url:deleteProductNoticeUrl+"?id="+item.id,
							data:{}
						}).then((response)=>{
							var defaultResult = this.responseDefaultHandle(response);
							if(defaultResult == false )
								return;
							this.$message({
								message: '已成功删除',
								type: 'success'
							});
							this.queryProductNotice();
						})
							.catch((error)=>{
								this.$message.error("删除失败");
							})
					});
				},
				currentPageChangeHandler:function (val) {
					this.currentPageIndex = val;
					this.queryProducts();
				},
				queryProductNotice:function () {
					if(this.loading == false ){
						this.loading = true;
						var param = {};
						param.productId = 0;
						this.$http.post(getProductNoticeListUrl,param).then(
							function(response){
								var defaultResult = this.responseDefaultHandle(response);
								if(defaultResult == false )
									return;
								var res = response.body;
								if(res.result==1){
									this.tableData = res.items;
								}else{
									this.$message.error(res.emsg);
								}
								this.loading=false;
							},function(){
								this.$message.error("获取产品公告列表失败");
								this.loading=false;
							})
					}
				},
				addProductNoticeSuccess:function () {
					this.showAddProductNoticePanel = false;
					this.queryProductNotice();
				},
				editProductNoticeSuccess:function () {
					this.showEditProductNoticePanel = false;
					this.queryProductNotice();
				}
			}
    }
</script>
<style scoped>
	.title{
		border-bottom: 1px solid #ddd;
		padding: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/layouts/productnotice/ProductNoticeQuery.vue